import HeaderBar from './header-bar'
export default HeaderBar



// WEBPACK FOOTER //
// ./src/components/main/components/header-bar/index.js